module.exports = __webpack_public_path__ + "static/testimonial-headshot-3.da094900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/testimonial-headshot-3.png
// module id = 199
// module chunks = 35783957827783 208176855801404